module.exports = __webpack_public_path__ + "img/40_69_000_130.cb61733c.jpg";